module.exports = __webpack_public_path__ + "img/adverbia_blanco.2fe9fe30.png";